import { useEffect, useRef } from "react";
import { Link, useOutletContext } from "react-router-dom";
import { TabNames, ChangeTypes, StreamingMarketDataV3MajorVersion } from "../Assets/variables";
import { versionHistory } from "../Assets/versionHistory";

const MajorVersionGroup = ({ majorVersion, isHidden }) => {
    const majorVersionButtonElement = useRef(null);
    const majorVersionEntriesElement = useRef(null);

    function scrollToElement(id) {
        const element = document.getElementById(id);
        element.scrollIntoView( { block: 'start' } );
    }

    const toggleContentItemVisibility = () => {
        if (majorVersionEntriesElement.current.classList.contains("hidden")) {
            majorVersionEntriesElement.current.classList.remove("hidden");
            majorVersionButtonElement.current.classList.add("shown");
        } else {
            majorVersionEntriesElement.current.classList.add("hidden");
            majorVersionButtonElement.current.classList.remove("shown");
        }
    }

    return (
        <div className="major-version-list">
            <button onClick={toggleContentItemVisibility} className={"major-version-list__button " + (isHidden ? 'hidden' : 'shown')} ref={majorVersionButtonElement}>
                {`Major Version ${majorVersion}`}
            </button>
            <div className={"major-version-list__item " + (isHidden ? 'hidden' : 'shown')} ref={majorVersionEntriesElement}>
                { Object.keys(versionHistory).map(changeLogEntry => ( versionHistory[changeLogEntry].majorVersion === majorVersion) &&
                    <Link
                        key={`${versionHistory[changeLogEntry].minorVersion}`}
                        onClick={() => {scrollToElement(`${versionHistory[changeLogEntry].minorVersion}`)}}
                        className="navigation__item navigation__item">
                            {`Major Version ${versionHistory[changeLogEntry].majorVersion} / Minor Version ${versionHistory[changeLogEntry].minorVersion}`}
                    </Link>
                )}
            </div>
        </div>
    );
}

const APIVersionHistoryStreamingMarketDataV3 = () => {
    const {setActiveTabItem, apiInfo} = useOutletContext();
    let changeLogEntries = {};
    let apiName = apiInfo.apiTitle;

    useEffect(() => {
        setActiveTabItem(TabNames.VersionHistory);
    }, []);

    Object.keys(versionHistory).map(changelog => {
        changeLogEntries[changelog] = {};
        changeLogEntries[changelog].changeList = [];
        changeLogEntries[changelog].changeList = versionHistory[changelog].changeList.filter((change) => change.apis.includes(apiName));
        changeLogEntries[changelog].majorVersion = versionHistory[changelog].majorVersion;
        changeLogEntries[changelog].minorVersion = versionHistory[changelog].minorVersion;
    });

    let versionNumbersInReverse = Object.keys(changeLogEntries).reverse();

    if (versionNumbersInReverse.length > 1) {
        for (let index = 1; index < versionNumbersInReverse.length; index++) {
            if (changeLogEntries[versionNumbersInReverse[index]].minorVersion === changeLogEntries[versionNumbersInReverse[index - 1]].minorVersion) {
                changeLogEntries[versionNumbersInReverse[index]].changeList = [];
            }
        }
    }

    return (
        <div id="tab-versionHistory" className="api-panel-version-history">
            <div className="api-version-history-navigation">
                <nav>
                    <MajorVersionGroup majorVersion={StreamingMarketDataV3MajorVersion} isHidden={false} />
                </nav>
            </div>
            <div className="api-version-history">
            { Object.keys(versionHistory).map(changeLogEntry => ( apiInfo.versions.filter( (version) => version === versionHistory[changeLogEntry].majorVersion)[0] &&
                <div className="api-version-history-log" key={`${versionHistory[changeLogEntry].minorVersion}`}>
                    <div className="api-version-history-log-inner">
                    <span className="header-2" id={`${versionHistory[changeLogEntry].minorVersion}`}>{`Major Version ${versionHistory[changeLogEntry].majorVersion} / Minor Version ${versionHistory[changeLogEntry].minorVersion}`}</span>
                    <h2 className="hidden">{`Release: ${versionHistory[changeLogEntry].minorVersion}`}</h2>
                        { versionHistory[changeLogEntry].changeList.length > 0 && <div>
                            <VersionHistoryTabCategory changeLog={changeLogEntries[changeLogEntry].changeList} type={ChangeTypes.Added} categoryTitle={"Added"} />
                            <VersionHistoryTabCategory changeLog={changeLogEntries[changeLogEntry].changeList} type={ChangeTypes.Changed} categoryTitle={"Changed"} />
                            <VersionHistoryTabCategory changeLog={changeLogEntries[changeLogEntry].changeList} type={ChangeTypes.Deprecated} categoryTitle={"Deprecated"} />
                            <VersionHistoryTabCategory changeLog={changeLogEntries[changeLogEntry].changeList} type={ChangeTypes.Removed} categoryTitle={"Removed"} />
                            <VersionHistoryTabCategory changeLog={changeLogEntries[changeLogEntry].changeList} type={ChangeTypes.Fixed} categoryTitle={"Fixed"} />
                            <VersionHistoryTabCategory changeLog={changeLogEntries[changeLogEntry].changeList} type={ChangeTypes.Security} categoryTitle={"Security"} />
                        </div>
                        }
                        { changeLogEntries[changeLogEntry].changeList.length === 0 && <div>
                            <p>There were no changes for this API.</p>
                        </div>
                        }
                    </div>
                    <hr />
                </div>
                )
            )}
            </div>
        </div>
    );
}

const VersionHistoryTabCategory = (props) => {

    function hasCategory(logs, category) {
        let doesContain = [];

        logs.map(log => {
            doesContain.push(log.type)
        });

        return doesContain.includes(category);
    }

    function createMarkup(message) {
        return {__html: message};
    }

    return (
        <>
            { hasCategory(props.changeLog, props.type) && <>
                <ReleaseNoteChip type={props.type} />
                { props.changeLog.map(entry => {
                    if (entry.type === props.type) {
                        return (<div dangerouslySetInnerHTML={createMarkup(entry.message)}></div>)
                    }
                }) }
            </>
            }
        </>
    )
}

function ReleaseNoteChip(props) {
    const type = props.type;

    if (type === ChangeTypes.Added) {
        return (
            <div className="note-type-chip note-type-chip--added">
                <span className="material-icons-outlined">add_circle_outline</span>
                <span className="chip-type">{ChangeTypes.Added}</span>
            </div>
        );
    }

    if (type === ChangeTypes.Deprecated) {
        return (
            <div className="note-type-chip note-type-chip--deprecated">
                <span className="material-icons-outlined">error_outline</span>
                <span className="chip-type">{ChangeTypes.Deprecated}</span>
            </div>
        );
    }

    if (type === ChangeTypes.Removed) {
        return (
            <div className="note-type-chip note-type-chip--removed">
                <span className="material-icons-outlined">remove_circle_outline</span>
                <span className="chip-type">{ChangeTypes.Removed}</span>
            </div>
        );
    }

    if (type === ChangeTypes.Changed) {
        return (
            <div className="note-type-chip note-type-chip--changed">
                <span className="material-icons-outlined">update</span>
                <span className="chip-type">{ChangeTypes.Changed}</span>
            </div>
        );
    }
};

export default APIVersionHistoryStreamingMarketDataV3;
